/* eslint-disable internal-rules/no-restricted-design-system-imports */
/* eslint-disable internal-rules/no-restricted-design-system-props */

import type { Icon } from '@change/ds-icons';
import { EmailOutlineIcon, FacebookRegularIcon, TwitterIcon, WhatsAppIcon } from '@change/ds-icons';

import { SocialSharing, SocialSharingGroup } from '@change/ds-core-ui/next';

import type { TranslationKey } from '@change-corgi/core/i18n';
import { useI18n } from '@change-corgi/core/react/i18n';

import { useShareLinks } from './hooks/useShareLinks';
import type { Channel } from './hooks/useShareLinks/types';

const socialIcons: Readonly<
	Record<
		Channel,
		Readonly<{
			icon: React.FC<Icon>;
			displayLabel: string;
		}>
	>
> = {
	facebook: {
		icon: FacebookRegularIcon,
		displayLabel: 'fe.components.psf.share.buttons.short.facebook',
	},
	twitter: {
		icon: TwitterIcon,
		displayLabel: 'fe.components.psf.share.buttons.short.twitter',
	},
	whatsapp: {
		icon: WhatsAppIcon,
		displayLabel: 'fe.components.psf.share.buttons.short.whatsapp',
	},
	email: {
		icon: EmailOutlineIcon,
		displayLabel: 'fe.components.psf.share.buttons.short.email',
	},
} as const;

export function ShareLinks() {
	const {
		data: { shareActions },
	} = useShareLinks();

	const { translate } = useI18n();

	const generateIcon = (channel: Channel | undefined, action: () => Promise<boolean>) => {
		const { icon: IconComponent, displayLabel } = socialIcons[channel as keyof typeof socialIcons];
		const variant = channel === 'email' ? 'default' : channel;
		return (
			<SocialSharing
				data-testid={`share-icon-${channel}`}
				key={`share-icon-${channel}`}
				icon={<IconComponent />}
				label={translate(displayLabel as unknown as TranslationKey)}
				onClick={action}
				size="large"
				variant={variant}
			/>
		);
	};

	return (
		<SocialSharingGroup className="mb-0 mt-6 flex flex-wrap gap-1 md:justify-start">
			{shareActions.map(({ channel, action }) => {
				return generateIcon(channel, action);
			})}
		</SocialSharingGroup>
	);
}
